import { useState, useEffect } from 'react';
import OrgBilling from './orgBilling';
import OrgPayouts from './orgPayouts';
import Tab from '../../components/tabs/tabs';
import { useLocation, useNavigate } from 'react-router-dom';

const OrgPaymentsTab = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [activeTab, setActiveTab] = useState('Billing');

    useEffect(() => {
        if (location.pathname.startsWith('/org/payouts')) {
            setActiveTab('Payouts');
        } else {
            setActiveTab('Billing');
        }
    }, [location.pathname]);

    const handleTabChange = (tab) => {
        setActiveTab(tab);
        navigate(tab === 'Billing' ? '/org/billing?status=completed&approval=approved&page=1' : '/org/payouts?page=1');
    };
    return (
        <>
            <div className='tabContainer bookingSticky'>
                <Tab label='Billing' value={'Billing'} activeTab={activeTab} setActiveTab={handleTabChange} />
                <Tab label='Payouts' value={'Payouts'} activeTab={activeTab} setActiveTab={handleTabChange} />
            </div>
            <div>
                {activeTab === 'Billing' && <OrgBilling />}
                {activeTab === 'Payouts' && <OrgPayouts />}
            </div>
        </>
    );
};

export default OrgPaymentsTab;
